<div *ngIf="truckModelsList">
  <div *ngFor="let truckModel of truckModelsList">
    <div class="truck-select-entry" (click)="setTruckModel(truckModel)">{{truckModel.model}}</div>
    <!--    <table>-->
    <!--      <tr *ngFor="let item of truckModel | keyvalue: originalOrder">-->
    <!--        <td>{{item.key}}</td>-->
    <!--        <td>{{item.value}}</td>-->
    <!--      </tr>-->
    <!--    </table>-->
  </div>
</div>
